import { Suspense, lazy } from 'react';

const Header = lazy(() =>
  import('@/components/landing/header').then(mod => ({ default: mod.Header })),
);
const AIHeroSection = lazy(() =>
  import('@/components/landing/ai-hero-section').then(mod => ({ default: mod.AIHeroSection })),
);
const HowItWorksSection = lazy(() =>
  import('@/components/landing/how-it-works-section').then(mod => ({
    default: mod.HowItWorksSection,
  })),
);
const AIPainPointsSection = lazy(() =>
  import('@/components/landing/ai-pain-points-section').then(mod => ({
    default: mod.AIPainPointsSection,
  })),
);
const AISolutionsSection = lazy(() =>
  import('@/components/landing/ai-solutions-section').then(mod => ({
    default: mod.AISolutionsSection,
  })),
);
const TestimonialsSection = lazy(() =>
  import('@/components/landing/testimonials-section').then(mod => ({
    default: mod.TestimonialsSection,
  })),
);
const AIStatsSection = lazy(() =>
  import('@/components/landing/ai-stats-section').then(mod => ({ default: mod.AIStatsSection })),
);
const AIFeaturesSection = lazy(() =>
  import('@/components/landing/ai-features-section').then(mod => ({
    default: mod.AIFeaturesSection,
  })),
);
const FAQSection = lazy(() =>
  import('@/components/landing/faq-section').then(mod => ({ default: mod.FAQSection })),
);
const AICTASection = lazy(() =>
  import('@/components/landing/ai-cta-section').then(mod => ({ default: mod.AICTASection })),
);
const Footer = lazy(() =>
  import('@/components/landing/footer').then(mod => ({ default: mod.Footer })),
);

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Suspense fallback={<div className="h-16" />}>
        <Header />
      </Suspense>

      <Suspense fallback={<div className="min-h-[600px]" />}>
        <AIHeroSection />
      </Suspense>

      <Suspense fallback={<div className="min-h-[400px]" />}>
        <HowItWorksSection />
      </Suspense>

      <Suspense fallback={<div className="min-h-[400px]" />}>
        <AIPainPointsSection />
      </Suspense>

      <Suspense fallback={<div className="min-h-[400px]" />}>
        <AISolutionsSection />
      </Suspense>

      <Suspense fallback={<div className="min-h-[400px]" />}>
        <TestimonialsSection />
      </Suspense>

      <Suspense fallback={<div className="min-h-[300px]" />}>
        <AIStatsSection />
      </Suspense>

      <Suspense fallback={<div className="min-h-[400px]" />}>
        <AIFeaturesSection />
      </Suspense>

      <Suspense fallback={<div className="min-h-[400px]" />}>
        <FAQSection />
      </Suspense>

      <Suspense fallback={<div className="min-h-[300px]" />}>
        <AICTASection />
      </Suspense>

      <Suspense fallback={<div className="min-h-[200px]" />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default LandingPage;
